import React from 'react';
import PropTypes from 'prop-types';

import s from './index.module.scss';

const LoadingText = ({ text = 'Loading' }) => (
  <div className={s['loading-text']}>
    {text}
    <span>.</span>
    <span>.</span>
    <span>.</span>
  </div>
);

LoadingText.propTypes = {
  text: PropTypes.string,
};

export default LoadingText;
